<template>
  <div>
    <b-form-input
      v-model="field"
      class="form-control form-control-sm"
      :id="id"
      @blur="popoverShow = false"
      @keyup.native="Search"
    />

-{{location}}
    <b-popover
      ref="popover"
      :target="id"
      :show.sync="popoverShow"
      :disabled.sync="popoverDisabled"
      placement="bottom"
      container="my-container"
    >
      <template v-slot:title>
        <div class="d-flex justify-content-between align-items-center">
          <span>Adresssuche</span>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            class="close"
            variant="transparent"
            aria-label="Close"
          >
            <span
              class="d-inline-block text-white"
              aria-hidden="true"
            >&times;</span>
          </b-button>
        </div>
      </template>

      <div>
        <b-table responsive="xl"
                 class="row-pointer"
                 :items="items"
                 :fields="fields"
        />
      </div>
    </b-popover>
  </div>
</template>

<script>
import { BButton, BFormInput, BPopover, BTable } from 'bootstrap-vue'

export default {
  name: 'AddressAutocomplete',
  components: {
    BTable,
    BButton,
    BPopover,
    BFormInput
  },
  computed: {
    make() {
      this.id = this.makeid(24);
    }
  },
  data() {
    return {
      location: '',
      zipCode: '',
      id: this.makeid(48),
      timeout: null,
      field: '',
      response: null,
      fieldSelected: '',
      selected: null,
      popoverShow: false,
      popoverDisabled: false,
      showLimit: 5,
      inputTimeout: null,
      fields: [
        {
          key: 'Address',
          label: 'Adresse',
        },
      ],
      items: [],
    }
  },

  methods: {
    Set(value) {
      console.log("#################################")
      this.field = value;
    },
    makeid(length) {
      let result = ''
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      const charactersLength = characters.length
      for (let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    Search() {

      this.popoverShow = true;
      clearTimeout(this.inputTimeout)
      this.inputTimeout= setTimeout(() => {
        this.$http.post('/address/search/address', JSON.stringify({
          ZipCode: '',
          Location: '',
          Street: this.field,
        }))
          .then(resp => {
            if (resp.data.success) {
              resp.data.list.forEach(i => {
                this.items.push(i)
              })
            }
          })
          .catch(err => {
            console.error(err)
          })

      }, 500)
    },
  }
}
</script>

<style scoped>

</style>